import { noddiColors } from 'noddi-ui-common';
import type { ReactNode } from 'react';
import { MapLegend, MapLegendItem } from './markers/MapLegend';
import { MapMarkerIcon } from './markers/MapMarkerIcon';

type Props = {
  pickupLabel?: string;
  /** Pass `null` to hide the address legend row. */
  addressLabel?: string | null;
  radiusMeters?: number;
  onCenterPickup?: () => void;
  onCenterAddress?: () => void;
  centerPickupTitle?: string;
  centerAddressTitle?: string;
  allowedAreaLabel?: string;
  /** Override the selected-location legend glyph (defaults to blue map pin). */
  pickupIcon?: ReactNode;
  /** Override the address legend glyph (defaults to red map pin). */
  addressIcon?: ReactNode;
};

export const MapPinSelectionLegend = ({
  pickupLabel = 'Car location',
  addressLabel = 'Address',
  radiusMeters,
  onCenterPickup,
  onCenterAddress,
  centerPickupTitle = 'Center map on pin',
  centerAddressTitle = 'Center map on address',
  allowedAreaLabel,
  pickupIcon,
  addressIcon
}: Props = {}) => (
  <MapLegend>
    <MapLegendItem
      icon={pickupIcon ?? <MapMarkerIcon />}
      onClick={onCenterPickup}
      title={onCenterPickup ? centerPickupTitle : undefined}
    >
      {pickupLabel}
    </MapLegendItem>
    {addressLabel !== null && (
      <MapLegendItem
        icon={addressIcon ?? <MapMarkerIcon red />}
        onClick={onCenterAddress}
        title={onCenterAddress ? centerAddressTitle : undefined}
      >
        {addressLabel}
      </MapLegendItem>
    )}
    {radiusMeters !== undefined && (
      <MapLegendItem
        icon={<RadiusSwatch />}
        onClick={onCenterAddress}
        title={onCenterAddress ? centerAddressTitle : undefined}
      >
        {allowedAreaLabel ?? `Allowed area (${radiusMeters} m)`}
      </MapLegendItem>
    )}
  </MapLegend>
);

const RadiusSwatch = () => (
  <svg viewBox='0 0 16 16' className='size-4' aria-hidden='true' focusable='false'>
    <circle
      cx='8'
      cy='8'
      r='6'
      fill={noddiColors.noddiPurple}
      fillOpacity='0.08'
      stroke={noddiColors.noddiPurple}
      strokeWidth='1.5'
      strokeDasharray='3 3'
    />
  </svg>
);
